import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../Common/Layout";

export default function DeleteData() {
  const [search, setSearch] = useState("");

  const [clients, setClients] = useState([]);

  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  /* ===============================
        FETCH CLIENTS
  =============================== */
  const fetchClients = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/delete/master-client",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setClients(res.data.data || []);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to load clients",
      });
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  /* ===============================
        Update CLIENT
  =============================== */



const editClient = (client) => {
  navigate(`/master-client/edit/${client.id}`);
};



  const filteredClients = clients.filter((client) => {
    const text = search.toLowerCase();

    return (
      client.crdNo?.toLowerCase().includes(text) ||
      client.company_name?.toLowerCase().includes(text) ||
      client.contact_number?.toLowerCase().includes(text) ||
      client.product?.toLowerCase().includes(text) ||
      client.status?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <h3 className="fw-bold mb-4">✏️ Master Client Update Panel</h3>
      <div className="mb-3">
        <input
          type="text"
          className="form-control border-primary"
          placeholder="🔍 Search CRD No / Company / Contact / Product / Status..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-responsive shadow-sm">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>CRD No</th>
              <th>Company</th>
              <th>Contact</th>
              <th>Product</th>
              <th>Status</th>
              <th width="120">Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredClients.length > 0 ? (
              filteredClients.map((client) => (
                <tr key={client.id}>
                  <td>{client.crdNo}</td>
                  <td>{client.company_name}</td>
                  <td>{client.contact_number}</td>
                  <td>{client.product}</td>
                  <td>
                    <span
                      className={`badge ${
                        client.status === "APPROVED"
                          ? "bg-success"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {client.status}
                    </span>
                  </td>

                  <td>
                  
		   <button
                     className="btn btn-primary btn-sm"
                     onClick={() => editClient(client)}
                     >
                    ✏️ Update
                      </button>
                   
		  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No Clients Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
